import { Component, Input } from '@angular/core';
import { Order } from '../../../../graphql/generated/generated-types';
import { ItemPaymentTotalsComponent } from '../../payment-summary-block/item-payment-totals/item-payment-totals.component';
import { CouponCodeInputComponent } from '../../coupon-code-input/coupon-code-input.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { RouterLink } from '@angular/router';
import { StateService } from '../../../../core/state/old/state.service';

@Component({
  selector: 'app-cart-price-and-actions-block',
  standalone: true,
  imports: [ItemPaymentTotalsComponent, CouponCodeInputComponent, ButtonModule, RippleModule, RouterLink],
  templateUrl: './cart-price-and-actions-block.component.html',
  styleUrl: './cart-price-and-actions-block.component.scss'
})
export class CartPriceAndActionsBlockComponent {
  @Input() order: Order;

  constructor(private stateService: StateService){

  }

  public closeCartSidenav(){

    this.stateService.setState('cartSidebarVisible', false);
  }

}
